<template>
    <div :class="['dashboard-table-container', tableData.length < 10 ? 'height'+ tableData.length : '' ] ">
        <el-table
                ref="dashboardTableRef"
                :data="tableData"
                border
                show-summary
                :sum-text="$t('total')"
                :summary-method="getSummaries"
                :header-cell-class-name="tableHeaderCls"
                stripe
                class="dashboard-table-cls"
                style="width: 100%"
            >
            <el-table-column
                    v-for="(item, index) in labelList"
                    :key="item.code"
                    :prop="item.code"
                    :align="item.align || 'left'"
                    :min-width="item.minWidth"
                    :width="item.width">
                <template #header>
                    <span v-html="$i18n.locale === 'en' ? item.name.en_name : item.name.zh_name"></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "DashboardTable",
        props: {
            tableData: {
                type: Array,
                default: () => []
            },
            tableDataSource: {
                type: Array,
                default: () => []
            },
            showConfirmationReplyStatus: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                
            }
        },
        computed: {
            labelList() {
                let labelList = [
                    {
                        code: 'entityName',
                        name: {
                            zh_name: '被审计单位名称',
                            en_name: 'Audited entity',
                        },
                        minWidth: 100,
                    },
                    {
                        code: 'draftNum',
                        name: {
                            zh_name: '制作中函证',
                            en_name: 'Under preparation',
                        },
                        align: 'center'
                    },
                    {
                        code: 'pendingForClientAuthorisationNum',
                        name: {
                            zh_name: '待被审计单位授权',
                            en_name: 'Pending for Authorisation',
                        },
                        minWidth: 100,
                        align: 'center'
                    },
                    {
                        code: 'authorisedConfirmationSentToKPMGNum',
                        name: {
                            zh_name: '已签字盖章并寄往毕马威<br /> (适用于纸质函证)',
                            en_name: 'Stamped/signed and sent to KPMG<br />(for hardcopy confirmations)',
                        },
                        minWidth: 110,
                        align: 'center'
                    },
                    {
                        code: 'authorizationCompletedNum',
                        name: {
                            zh_name: '已发往被函证方',
                            en_name: 'Sent to Addressee',
                        },
                        align: 'center',
                        minWidth: 120,
                    },
                ]

                if (this.showConfirmationReplyStatus) {
                    labelList.push({
                        code: 'status5',
                        name: {
                            zh_name: this.$t('confirmation_status._5'),
                            en_name: this.$t('confirmation_status._5'),
                        },
                        align: 'center',
                        minWidth: 120,
                    }, {
                        code: 'status6',
                        name: {
                            zh_name: this.$t('confirmation_status._6'),
                            en_name: this.$t('confirmation_status._6'),
                        },
                        align: 'center',
                        minWidth: 120,
                    })
                }

                labelList.push({
                    code: 'total',
                    name: {
                        zh_name: '合计',
                        en_name: 'Total',
                    },
                    width: 90,
                    align: 'center'
                })

                return labelList
            }
        },
        updated() {
            this.$nextTick(() => {
                this.$refs.dashboardTableRef.doLayout()
            })
        },
        methods: {
            tableHeaderCls({row, column, rowIndex, columnIndex}){
                switch(columnIndex){
                    case 1: return 'color1';         
                    case 2: return 'color2';        
                    case 3: return 'color3';     
                    case 4: return 'color4';     
                    case 5: return 'color5';   
                    case 6: return 'color6';   
                        default: return ''
                }
            },
            getSummaries() {
                let draft = 0
                let pendingFor = 0
                let sentToKPMG = 0
                let completed = 0
                let status5 = 0
                let status6 = 0
                let total = 0
                this.tableDataSource.forEach(item => {
                    draft += item.draftNum || 0
                    pendingFor += item.pendingForClientAuthorisationNum || 0
                    sentToKPMG += item.authorisedConfirmationSentToKPMGNum || 0
                    completed += item.authorizationCompletedNum || 0
                    status5 += item.status5
                    status6 += item.status6
                })
                total = draft + pendingFor + sentToKPMG + completed
                if (this.showConfirmationReplyStatus) {
                    total += status5 + status6
                }
                return this.showConfirmationReplyStatus ?
                    [this.$t('total'), draft, pendingFor, sentToKPMG, completed, status5, status6, total] :
                    [this.$t('total'), draft, pendingFor, sentToKPMG, completed, total]
            }
        }
    }
</script>

<style scoped>
    /* .dashboard-table-container {
        height: 474px;
    }

    .height0, .height1 {
        height: 121px;
    } */

    .height2 {
        height: 161px;
    }

    .height3 {
        height: 200px;
    }

    .height4 {
        height: 240px;
    }

    .height5 {
        height: 278px;
    }

    .height6 {
        height: 318px;
    }

    .height7 {
        height: 357px;
    }

    .height8 {
        height: 395px;
    }

    .height9 {
        height: 435px;
    }

    .dashboard-table-cls ::v-deep .el-table__footer-wrapper tbody td.el-table__cell {
        background-color: rgb(243, 247, 255);
    }

    ::v-deep .color1 {
        background-color: #989898 !important;
        color:#ffffff !important;;
    }
    ::v-deep .color2{
        background-color: #fd349c !important;
        color: #ffffff !important;;
    }
    ::v-deep .color3{
        background-color: #00b8f5 !important;
        color: #ffffff !important;;
    }
    ::v-deep .color4{
        background-color: #1e49e2 !important;
        color: #ffffff !important;;
    }
    ::v-deep .color5{
        background-color: #00338d !important;
        color: #ffffff !important;;
    }
    ::v-deep .color6{
        background-color: #269924 !important;
        color: #ffffff !important;;
    }
</style>